import { ROUTE_NAMES } from '~/constants/routes'

export function getListingCreateRoute(onboardingCompleted: boolean) {
  return onboardingCompleted
    ? ROUTE_NAMES.LISTINGS.PRODUCT.SEARCH
    : ROUTE_NAMES.ONBOARDING.LISTINGS.CREATE.PRODUCT.SEARCH
}

export function getActiveListingsRoute(
  onboardingCompleted: boolean,
  shouldUseNewListingsPage: boolean,
) {
  const onboardingRoute = shouldUseNewListingsPage
    ? ROUTE_NAMES.ONBOARDING.LISTINGSV2.TABS.ACTIVE
    : ROUTE_NAMES.ONBOARDING.LISTINGS.TABS.ACTIVE

  const listingsRoute = shouldUseNewListingsPage
    ? ROUTE_NAMES.LISTINGSV2.INDEX
    : ROUTE_NAMES.LISTINGS.INDEX

  return onboardingCompleted ? listingsRoute : onboardingRoute
}

export function shouldDisableNewBatteryToggle(
  aestheticGrade: number | null | undefined,
) {
  // If the selected grade is Premium we should disable the New Battery toggle
  return aestheticGrade === 9
}
